import { Link } from "react-router-dom";
import { institutesDetails } from "./constant";
import "../../shared/styles/index.css";

const Course_Card = ({ id }) => {
  return (
    <div className="course-container" id={id}>
      <p className="course-title">Top MBA Courses Provided by Us</p>

      <div className="course-wrapper">
        {institutesDetails.map((institute) => (
          <Link
            to={`${institute.instituteLink}`}
            key={institute._id}
            className="course-card"
          >
            <img
              style={{ width: "100px", marginBottom: "10px" }}
              src={institute.instituteImage}
              alt="course icon"
            />
            <p>{institute.instituteName}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Course_Card;
